import { FUSION_API } from '../shared/api';
import { get } from '../shared/helpers';

export default class FusionAPI {
  static get(path) {
    return get(`${FUSION_API}/${path}`, null, { token: true });
  }
}
